var React = require('react');

function IconHamburger (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"height":"2","x":"0","y":"20%","key":0}),React.createElement("rect",{"height":"2","x":"0","y":"45%","key":1}),React.createElement("rect",{"height":"2","x":"0","y":"70%","key":2})]);
}

IconHamburger.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = IconHamburger;

IconHamburger.default = IconHamburger;
